import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { FacilityInfo } from '../../../../src/web/components';
import StarRack from '../../stateless/StarRack';
import Translation from '../../stateless/Translation';
import classes from './SuccessModal.scss';

const propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  review: PropTypes.shape({
    rating: PropTypes.number.isRequired,
  }),
  facility: PropTypes.object,
};

const defaultProps = {
  show: false,
  facility: undefined,
  review: undefined,
};

function renderBody({ facility, review }) { // eslint-disable-line react/prop-types
  if (!facility || !review) {
    return <Modal.Body />;
  }

  return (
    <Modal.Body className={classes.body}>
      <StarRack className={classes.starRack} rating={review.rating} />
      <Translation
        id="widgets.reviewButton.successModal.body"
        defaultMessage="Your review has been successfully submitted, and we really appreciate your feedback. Thank you for reviewing our facility!" // eslint-disable-line max-len
      >
        {text => <p className={classes.facilityInfo}>{text}</p>}
      </Translation>
      <FacilityInfo facility={facility} className={classes.facilityInfo} />
    </Modal.Body>
  );
}

const SuccessModal = ({
  show = false,
  onClose,
  facility,
  review,
}) => (
  <Modal onHide={onClose} keyboard show={show}>
    <Modal.Header closeButton>
      <Modal.Title className={classes.centeredTitle}>
        <Translation id="widgets.reviewButton.successModal.title" defaultMessage="Thank you!">
          {text => (
            <h2 className={`color-primary-foreground ${classes.heading}`}>
              {text}
            </h2>
          )}
        </Translation>
      </Modal.Title>
    </Modal.Header>
    {renderBody({ facility, review })}
  </Modal>
);

SuccessModal.propTypes = propTypes;
SuccessModal.defaultProps = defaultProps;

export default connect(
  ({ facilities }, { review }) => {
    let facility;
    if (review) {
      if (facilities.info[review.facilityId]) {
        facility = facilities.info[review.facilityId];
      } else {
        facility = facilities.allFacilities.find(({ id }) => id === review.facilityId);
      }
    }

    return { facility };
  },
  {},
)(SuccessModal);
